import { Component, OnInit, ViewChild, Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { DateAdapter, NativeDateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { DPO_CONSTANT } from './../../utils/constant';
import { OperationDetailsDialogBoxComponent } from '../operation-details-dialog-box/operation-details-dialog-box.component';
import { ConsultationService } from './../../services/consultation.service';
import { DatePipe } from './../../pipes/date.pipe';
import { CacheService } from './../../services/cache.service';
import { CsvService } from './../../services/csv.service';
/* CAP-20457 : DAAS-42 : Start - Imported packages*/
import { NgxSpinnerService } from "ngx-spinner"; 
import { TranslateService} from '@ngx-translate/core';    //CAP-20457  : LOT1.1 - TranslateService for JSON Translation
import { AppConfig } from './../../modules/app.config';   //CAP-20753: Imported AppConfig file for Client related Changes

import { element } from 'protractor'; 
/* CAP-20457 : DAAS-42 : End */
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } else if (displayFormat && (displayFormat['month'] === 'long' || displayFormat['month'] === 'short')) {
      let months: string[] = this.getMonthNames(displayFormat['month']);
      let month: string = (date.getMonth()).toString();
      let year = date.getFullYear();
      return `${months[month]} ${year}`;
    }
    return date.toString();
  }
}

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'numeric', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' }
  }
};

@Component({
  selector: 'dpo-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class ConsultationComponent implements OnInit {

  // Define component properties
  maxDate = new Date();
  searchTemp: any ={};                               //CAP-20457: DAAS-42 : Variable declaration.
  subscriptionTemp: Array<any>= [];                  //CAP-20457: DAAS-42 : Variable declaration.
  DPO_CONSTANT = DPO_CONSTANT;
  searchResult: any = {};
  subscriptionList: Array<any> = [];
  subscriptionOptions: Array<any> = [];
  operationResult: any = {};
  operationList: Array<any> = [];

  rrdiAutoCompleteForm = new FormControl();
  rrdiAutoCompleteList: string[] = [];
  rrdiAutoCompleteFilteredOptions: Observable<string[]>;
  rrdiAutoCompleteMinCharacter = 3;
  // CAP-26096 :Start- Added two columns billable and Transaction Reference
   // CAP-29963 :POUDG-8878: Start- Added columns Service Contract

  displayedColumns: string[] = ['rrdi', 'vin', 'prestation', 'ecu', 'subscriptionLabel', 'subscriptionDate', 'basketFolderNumber', 'billable','serviceContract','transFeatureId','action'];
  dataSource = new MatTableDataSource(this.subscriptionList);
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  @ViewChild('sort', { static: true }) sort: MatSort;

  rrdi: string;
  vin: string;
  basketFolderNumber: string;
  subscriptionStatus: string = '0';
  fromSubscriptionDate: string;
  toSubscriptionDate: string;
  // CAP-26096 :Start- Added two variable isBillable and transFeatureId
  isBillable: boolean = false;		
  transFeatureId: string;
  serviceContract: boolean ; //// CAP-29963:POUDG-8878: Start- Added  variable serviceContract

  queryParams: any;
  userRoles: any;
  applicationName: any;   // Cap-20753 : Declaring applicationName
  userId: any;    	  // Cap-20753 : Declaring userId
  pageCount:number;
  country:string;                         // CAP-26096 :Declared country 
  transactionalFeatureIdValue: string;		// CAP-26096 :Declared transactionalFeatureIdValue 

  constructor(private consultationService: ConsultationService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private matDialog: MatDialog,
    private translate1:TranslateService,   //CAP-20457: LOT1.1 : TranslateService passed in Constructor for JSON Translations
    private cacheService: CacheService,
    private csvService: CsvService,
    private apiconfig :AppConfig,          //CAP-20753: Added AppConfig in Constructor for Client related Changes
    private dateAdapter: DateAdapter<any>,
    private SpinnerService: NgxSpinnerService) { }

  ngOnInit() {
    this.intializeTable();

    //CAP-20457: LOT1.1 : START- JSON Translation language called using localStorage
    if(localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE)) {
      this.translate1.use(localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));
    }
    else {
      this.translate1.use(DPO_CONSTANT.DEFAULT_LOCALE);
      localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, DPO_CONSTANT.DEFAULT_LOCALE);
    }
    // Load language for date component
    let locale = localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);  
    //CAP-20457: LOT1.1 : STOP- JSON Translation language called using localStorage 
    if (locale) {
      let localeCode = locale.split('-')[0];
      this.dateAdapter.setLocale(localeCode);
    }
    this.userRoles = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLES);
    this.applicationName = this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME);    // Cap-20753 : Assigning the application name 
    this.userId = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ID);    // Cap-20753 : Assigning the userId 
    this.country= this.cacheService.getItem(DPO_CONSTANT.CACHE_COUNTRY);    // CAP-26096 :Assigning country 
    this.pageCount= this.apiconfig.pageCount;    //CAP-20753: Fetched page count from AppConfig for Client related Changes
    // Fetch query params
    this.queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
    if (this.queryParams) {
      if (this.queryParams[DPO_CONSTANT.QP_RRDI_CODE]) {
        this.rrdi = this.queryParams[DPO_CONSTANT.QP_RRDI_CODE];
      }
      if (this.queryParams[DPO_CONSTANT.QP_VIN]) {
        this.vin = this.queryParams[DPO_CONSTANT.QP_VIN];
      }
    }
    this.cacheService.setItem(DPO_CONSTANT.CACHE_PAGE_FLAG,'C');
    // Remove duplicate calls for API
    let currentUrl = window.location.href.split('/#')[1];
    if (currentUrl === '/' + DPO_CONSTANT.PATH_CONSULTATION) {
      this.getSubscriptionOptions();
      this.getRrdiAutoCompleteList();
    }

    // Initialize filter for RRDI autocomplete
    this.rrdiAutoCompleteFilteredOptions = this.rrdiAutoCompleteForm.valueChanges
      .pipe(
        startWith(''),
        map(rrdi => this.filterRrdi(rrdi))
      );
  }

  // Method to filter the RRDI for antocomplete
  filterRrdi(rrdi: string) {
    if (rrdi && rrdi.length >= this.rrdiAutoCompleteMinCharacter) {
      const filterValue = rrdi.toLowerCase();
      return this.rrdiAutoCompleteList.filter(option => option.toLowerCase().includes(filterValue));
    } else {
      return undefined;
    }
  }

  // Intialize the table to intial state
  intializeTable() {
    this.dataSource = new MatTableDataSource(this.subscriptionList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // Method to call the all the subscription status
  getSubscriptionOptions() {
    this.SpinnerService.show();  
    this.consultationService.getSubscriptionOptions()
      .subscribe(response => {
        this.SpinnerService.hide();  
        this.subscriptionOptions = <any>response;
       /* CAP-20457: DAAS-42 : END */
      }, error => {
        this.SpinnerService.hide();  
        this.toastrService.error(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
      });
  }

  // Method to get the all the available RRDI for autocomplete
  getRrdiAutoCompleteList() {
    this.SpinnerService.show();  
    this.consultationService.getRrdiAutoCompleteList()
      .subscribe(response => {
        this.SpinnerService.hide(); 
        this.rrdiAutoCompleteList = <any>response;
      }, error => {
        this.SpinnerService.hide(); 
        this.toastrService.error(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
      });
  }

  // Method to call the filter the search records 
  search() {
    // Check for the date validation
    if (this.fromSubscriptionDate && this.toSubscriptionDate) {
      let fromDate = new Date(this.fromSubscriptionDate).getTime();
      let toDate = new Date(this.toSubscriptionDate).getTime();
      if ((toDate - fromDate) < 0) {
        this.toastrService.error(this.translate1.instant('dpo.i18n.message.date.validRange'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        return false;
      }
    }
    this.dataSource.data.splice(0, this.subscriptionList.length);
    // Prepare the parameters for the search API
    let params: any = {
      rrdi: this.rrdi ? this.rrdi.trim() : '',
      vin: this.vin ? this.vin.trim() : '',
      basketFolderNumber: this.basketFolderNumber ? this.basketFolderNumber.trim() : '',
      subscriptionStatus: (this.subscriptionStatus && this.subscriptionStatus.trim() != "0") ? this.subscriptionStatus.trim() : '',
      fromSubscriptionDate: this.datePipe.transform(this.fromSubscriptionDate),
      toSubscriptionDate: this.datePipe.transform(this.toSubscriptionDate),
      userRoles: this.userRoles,
      applicationName: this.applicationName,    // Cap-20753 : providing the app name
      userId:this.userId,                       // Cap-20753 : providing userId
      country:this.country,                      // CAP-26096 : providing country
      isBillable:this.isBillable,                // CAP-26096 : providing isBillable 
      serviceContract: this.serviceContract  ,    // CAP-29963 :POUDG-8878: providing serviceContract  
      transFeatureId: this.transFeatureId      // CAP-26096 : providing transFeatureId 
     
    };
    // Call the API for search
    this.SpinnerService.show();  
    this.consultationService.search(params)
      .subscribe(response => {
        this.SpinnerService.hide();

       this.searchResult = response;
        if (this.searchResult && this.searchResult['subscriptionRepresentations'] && this.searchResult['subscriptionRepresentations'].length > 0) {
          if (this.searchResult['subscriptionRepresentations'].length <= this.pageCount) {
            this.subscriptionList = this.searchResult['subscriptionRepresentations'];
            this.intializeTable();
            this.toastrService.success(this.translate1.instant('dpo.i18n.message.record.found'), this.translate1.instant('dpo.i18n.message.toastr.success'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          } else {
            this.subscriptionList = [];
            this.toastrService.warning(this.translate1.instant('dpo.i18n.message.consultation.search.exceed100'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
        } else {
          this.toastrService.warning(this.translate1.instant('dpo.i18n.message.record.notfound'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      }, error => {
        this.SpinnerService.hide();
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      });
  }

  // Method to prepare the operation dialog data
  prepareDialogBoxData(subscriptionId) {
    if (subscriptionId) {
      this.operationResult = {};
      this.operationList = [];
      let params: any = {
        id: subscriptionId
      };
      // Call the API to fetch the operation details for selected item
      this.consultationService.details(params)
        .subscribe(response => {
          this.operationResult = response
          if (this.operationResult && this.operationResult['vinInstantiatedSubscriptionRepresentations'] && this.operationResult['vinInstantiatedSubscriptionRepresentations'].length > 0) {
            for (let operation of this.operationResult['vinInstantiatedSubscriptionRepresentations']) {
              operation['rrdi'] = this.operationResult['rrdi'] ? this.operationResult['rrdi'] : '';
              operation['vin'] = this.operationResult['vin'] ? this.operationResult['vin'] : '';
              operation['basketFolderNumber'] = this.operationResult['basketFolderNumber'] ? this.operationResult['basketFolderNumber'] : '';
              operation['prestation'] = this.operationResult['prestation'] ? this.operationResult['prestation'] : '';
              operation['appCode'] = this.operationResult['appCode'] ? this.operationResult['appCode'] : '';
              operation['subscriptionDate'] = this.operationResult['subscriptionDate'] ? this.operationResult['subscriptionDate'] : '';
              operation['brand'] = this.operationResult['brand'] ? this.operationResult['brand'] : '';
              this.operationList.push(operation);
            }
            this.openDialogBox({ subscriptionId: subscriptionId, operationResult: this.operationResult, operationList: this.operationList });
            this.toastrService.success(this.translate1.instant('dpo.i18n.message.record.found'), this.translate1.instant('dpo.i18n.message.toastr.success'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          } else {
            this.toastrService.warning(this.translate1.instant('dpo.i18n.message.operation.record.notfound'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
        }, error => {
          if (error && error.status && error.status === 404 && error.error) {
            this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
            
          } else {
            this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
        });
    }
  }

  // Method to open the dialog box with data and basic configuration
  openDialogBox(data: any) {
    const dialogRef = this.matDialog.open(OperationDetailsDialogBoxComponent, {
      width: '1250px',
      maxWidth: '100vw',
      data: data
    });
  }

   // CAP-26096: Method to validate the transactionalFeatureId
   validateTransactionalFeatureId(value: number) {
    this.transactionalFeatureIdValue = '';
    let flag: boolean;
    if (value) {
      if (value) {
        flag = true;
      } else {
        flag = false;
      }
    }
    return flag;
   }

  // Method to export the data to CSV file
  export() {
    if (this.subscriptionList && this.subscriptionList.length > 0) {
      //Prepare the headers for the CSV file
      //CAP-20457: LOT1.1: START: Translation Service changed to translate for JSON
      const csvHeaders = [
        this.translate1.instant('dpo.i18n.table.header.rrdi'),
        this.translate1.instant('dpo.i18n.table.header.vin'),
        this.translate1.instant('dpo.i18n.table.header.prestation'),
        this.translate1.instant('dpo.i18n.table.header.ecu'),
        this.translate1.instant('dpo.i18n.table.header.status'),
        this.translate1.instant('dpo.i18n.table.header.subscription.date'),
        this.translate1.instant('dpo.i18n.table.header.backetFolderNumber'),
        this.translate1.instant('dpo.i18n.table.header.billable'),          //CAP-26096- Added Billable coulmn with translations
        this.translate1.instant('dpo.i18n.table.header.serviceContract'),     //CAP-29963 : POUDG-8878-  Added Service Contract coulmn with translations
        this.translate1.instant('dpo.i18n.table.header.transFeatureId')     //CAP-26096- Added Translation Reference coulmn with translation
      ];
      //CAP-20457: LOT1.1: STOP: Translation Service changed to translate for JSON

      // Prepare the data for CSV file
      let subscriptions = [];
      for (let subscriptionData of this.subscriptionList) {
        let subscription = {};
        subscription['rrdi'] = subscriptionData['rrdi'] ? subscriptionData['rrdi'] : '';
        subscription['vin'] = subscriptionData['vin'] ? subscriptionData['vin'] : '';
        subscription['prestation'] = subscriptionData['prestation'] ? this.translate1.instant(subscriptionData['prestation']) : '';
        subscription['ecu'] = subscriptionData['ecu'] ? subscriptionData['ecu'] : '';
        subscription['status'] = subscriptionData['subscriptionLabel'] ? this.translate1.instant(subscriptionData['subscriptionLabel']) : '';
        subscription['subscriptionDate'] = subscriptionData['subscriptionDate'] ? subscriptionData['subscriptionDate'] : '';
        subscription['basketFolderNumber'] = subscriptionData['basketFolderNumber'] ? subscriptionData['basketFolderNumber'] : '';
        subscription['billable'] = subscriptionData['billable'] ? this.translate1.instant(subscriptionData['billable']) : '';           //CAP-26096- Added Billable coulmn data
        subscription['serviceContract'] = subscriptionData['serviceContract'] ? subscriptionData['serviceContract'] : '';                     //CAP-29963 :POUDG-8878- Added Service Contract coulmn data
        subscription['tranFeatureId'] = subscriptionData['tranFeatureId'] ? subscriptionData['tranFeatureId'] : '';                     //CAP-26096- Added Transaction Reference coulmn data
        subscriptions.push(subscription);
      }

      this.csvService.save(csvHeaders, subscriptions, DPO_CONSTANT.CONSULTATION_EXPORT_FILENAME);
    } else {
      this.toastrService.warning(this.translate1.instant('dpo.i18n.message.export.empty'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    }
  }
}
